import React from 'react';

function Banner({ store, customerPhone }) {
  return (
    <div className="card2 card-primary mb-1">
      <div className="card-body pt-4 pe-4 pb-0 ps-4">
        <div>
          <h2 className="text-center pt-1">Welcome to LendNation!</h2>
          <div className="text-center pb-3">
            - Cash &amp; Title Loans -
          </div>
          <div className="banner-text">
            Our friendly team will reach out soon using the number you
            provided to guide you through the next steps. Prefer to
            move faster? <br />
            {store ? (
              <span>
                Call us at {store.phone} and we'll help get things
                started.
              </span>
            ) : (
              <span></span>
            )}
            <br />
            <br /> Here's how it works: speak with a representative,
            visit one of our convenient locations, and get a decision
            in minutes. It's quick, straightforward, and built around
            you.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
